<template>
    <div id="news">
        <div class="columns is-multiline">
            <div class="column" v-if="loading">
                <clip-loader ></clip-loader>
            </div>
            <div v-else class="column is-4-fullhd is-12-mobile is-10-tablet is-offset-1-tablet is-offset-4-fullhd">
                <p v-if="news.length == 0" class="has-text-centered"><b>No news found!</b></p>
                <news-item v-if="n.type != 'alert'" v-for="(n, index) in news" :item="n" :key="n.id"> </news-item>
            </div>
        </div>
    </div>
</template>
<script>

import NewsItem from '../components/news/NewsItem.vue'
import _ from 'lodash'


export default {
  name: 'news',
  components: {NewsItem},
  data() {
        return {
            loading: false,
            news : [],
        }
  },
  created(){

  },
  mounted(){
      this.getNews();
  },
  methods: {
      getNews(){
          this.loading = true;
          this.userRepo.news().then(response => {
              this.news = response.data.data;
              this.loading = false;
          }).catch((response) => {
              this.loading = false;
              return Promise.reject(response);
          });
      },
  },
  watch: {

  }

}

</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/News.vue